import Component from '../abstracts/Component';
import { trapFocusOnModal, removeTrapFocusOnModal } from '../utils/TrapFocus';

export default class MiniCartComponent extends Component {

  get SELECTORS() {
    return {
      minicartBtn: '[data-minicart-button]',
      minicartAccessibiltyBtn: '[data-minicart-accessibility-button]',
      minicartContent: '[data-minicart-content]',
      minicartContentNotify: '[data-minicartnotification-content]',
      minicartCount: '[data-mini-cart-qty]',
      minicartIcon: '[data-mini-cart-icon]',
      removeItemBtn: '[data-js-remove-item]',
      minicartAddToCartBtn: '#minicartAddToCartBtn',
      page: '#page-wrapper'
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  readDOM() {
    return {
      minicartBtn: this.$component.querySelector(this.SELECTORS.minicartBtn),
      minicartAccessibiltyBtn: this.$component.querySelector(this.SELECTORS.minicartAccessibiltyBtn),
      minicartContent: this.$component.querySelector(this.SELECTORS.minicartContent),
      minicartCount: this.$component.querySelector(this.SELECTORS.minicartCount),
      minicartIcon: this.$component.querySelector(this.SELECTORS.minicartIcon),
      minicartContentNotify: this.$component.querySelector(this.SELECTORS.minicartContentNotify),
      removeItemBtns: this.$component.querySelectorAll(this.SELECTORS.removeItemBtn),
      page: document.querySelector(this.SELECTORS.page)
    }
  }

  async updateMinicart() {
    const url = this.dom.minicartBtn.dataset.urlMiniCart;
    await fetch(url)
    .then(response => {
      return response.text();
    })
    .then(text => {
      const htmlResponse = new DOMParser().parseFromString(text, 'text/html');
      this.dom.minicartContent.innerHTML = htmlResponse.querySelector(this.SELECTORS.minicartContent).innerHTML;
      this.dom = this.readDOM();
      this.removeProductMiniCart();
    })
    .catch(error => console.error(error));
  }

  openQuickCartNotification(productCode) {
    const url = this.dom.minicartBtn.dataset.urlQuickCart+"?productCode="+productCode;
    fetch(url, { method: 'POST' })
    .then(response => {
      return response.text();
    })
    .then(text => {
      const htmlResponse = new DOMParser().parseFromString(text, 'text/html');
      this.dom.page.classList.add('--overlay');
      this.dom.minicartContentNotify.innerHTML = htmlResponse.querySelector(this.SELECTORS.minicartContent).innerHTML;
      this.dom.minicartContentNotify.classList.add("--open");
      const minicartAddToCartBtn = this.dom.minicartContentNotify.querySelector(this.SELECTORS.minicartAddToCartBtn);
      trapFocusOnModal(this.$component);
      this.dom.minicartContent.classList.add("hidden");
      const removeItemBtn = this.dom.minicartContentNotify.querySelector(this.SELECTORS.removeItemBtn);
      removeItemBtn.addEventListener("click", (event) => {
        event.preventDefault();
        const url = removeItemBtn.dataset.href;
        fetch(url, { method: 'POST' }).catch(error => console.error(error));
      });
      setTimeout(() => {
        this.dom.page.classList.remove('--overlay');
        this.dom.minicartContentNotify.classList.remove("--open");
        this.dom.minicartContent.classList.remove("hidden");
        this.dom.minicartContentNotify.innerHTML = '';
      }, 3000);
    })
    .catch((error) => {
      this.dom.page.classList.remove('--overlay');
      console.error(error);
    });
  }

  //remove item from quick cart --> do it every time the cart gets updated
  removeProductMiniCart() {
    if(this.dom.removeItemBtns) {
      this.dom.removeItemBtns.forEach(btn => {
        btn.addEventListener("click", (event) => {
          event.preventDefault();
          const url = btn.dataset.href;
          fetch(url, { method: 'POST' })
          .then(response => {
            const newCartQty = parseInt(this.dom.minicartCount.dataset.miniCartQty, 10) - 1;
            if(newCartQty >= 1) {
              this.dom.minicartCount.dataset.miniCartQty = newCartQty;
              this.dom.minicartCount.innerHTML = newCartQty;
            } else {
              this.dom.minicartCount.classList.add('hidden');
              this.dom.minicartIcon.className = "icon-cart-empty --m";
              this.dom.minicartCount.dataset.miniCartQty = newCartQty;
              this.dom.minicartCount.innerHTML = newCartQty;
            }
            this.updateMinicart();
          })
          .catch(error => console.error(error));
        })
      });
    }
  }

  handleAccessibilityButton() {
    this.dom.minicartAccessibiltyBtn.addEventListener("click", () => {
      this.dom.minicartAccessibiltyBtn.classList.toggle("--opened");
      this.$component.classList.toggle("--open");
      if(this.dom.minicartAccessibiltyBtn.classList.contains("--opened")) {
        this.dom.minicartAccessibiltyBtn.setAttribute("aira-expanded","true");
        this.trapFocusHandler = trapFocusOnModal(this.dom.minicartContent);
        this.dom.minicartContent.addEventListener('keydown', event => {
          if(event.key === "Escape") {
            this.dom.minicartAccessibiltyBtn.setAttribute("aira-expanded","false");
            this.dom.minicartAccessibiltyBtn.classList.remove("--opened");
            this.$component.classList.remove("--open");
            removeTrapFocusOnModal(this.$component, this.trapFocusHandler);
            this.trapFocusHandler = null;
            this.dom.minicartAccessibiltyBtn.focus();
          }
        });
      } else {
        this.dom.minicartAccessibiltyBtn.setAttribute("aira-expanded","false");
        this.dom.minicartAccessibiltyBtn.classList.remove("--opened");
        this.$component.classList.remove("--open");
        removeTrapFocusOnModal(this.$component, this.trapFocusHandler);
        this.trapFocusHandler = null;
      }
    });
  }

  bindEvents() {
    // update mini cart content + cart counter
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({event, payload}) => {
      this.dom.minicartCount.classList.remove('hidden');
      const newCartQty = parseInt(this.dom.minicartCount.dataset.miniCartQty, 10) + 1;
      this.dom.minicartCount.dataset.miniCartQty = newCartQty;
      this.dom.minicartCount.innerHTML = newCartQty;
      this.dom.minicartIcon.className = "icon-cart-full --m";
      this.updateMinicart();
    });

    // show quick cart notification
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({event, payload}) => {
      this.openQuickCartNotification(payload.productCode);
    });

    // quick cart close on dom click
    /*document.addEventListener('click',(e)=>{
      // if is open and i click outside the notification, close it
      if (this.minicartContentNotify.classList.contains(this.CLASSES.minicartOpened) && e.target.closest(this.SELECTORS.minicartContentNotify) == null ) {
        this.closeMinicartNotification();
      }
    });*/

    // communication popup timer logic //
    if(window.innerWidth >= 1024) {
      this.$component.addEventListener("mouseover", event => {
        this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
      });
      this.$component.addEventListener("mouseout", event => {
        if(document.body.dataset.jsLayerIsOpen == "false") {
          this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
        }
      });
    }

    this.handleAccessibilityButton();
  }

  render() {
    this.log('Rendering...');
    this.dom = this.readDOM();
    // on page load retrieve the mini cart content
    this.updateMinicart().then( res => {
      this.bindEvents();
    });
  }

}
